import React, { Fragment } from 'react'
import { Breadcrumbs, UL } from '../../../AbstractElements';
import DataGridInvoiceWiseView from './DataGridInvoiceWiseView';
import { Container } from 'reactstrap';

const InvoiceGrid = () => {
    // The "Live" suffix only disambiguates from the UAT grid, which only Backend
    // Users can see - everyone else just gets the plain name.
    const isBackendUser = localStorage.getItem("usertype") === "Backend User";
    const pageTitle = isBackendUser ? "Invoice Grid - Live" : "Invoice Grid";
    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent={pageTitle} title={pageTitle} mainTitle={pageTitle} />
                <Container fluid={true}>
                    <DataGridInvoiceWiseView />
                </Container>
            </Fragment>
        </UL>
    )
}

export default InvoiceGrid
